import React, { useCallback, useState } from 'react';
import { TeamMember } from './types';
import { StatCards } from './components/StatCards';
import { TeamSidebar } from './components/TeamSidebar';
import { MemberDetail } from './components/MemberDetail';
import { ReassignModal } from './components/ReassignModal';
import { Button } from './components/ui/Button';
import { LayoutDashboardIcon, ArrowRightLeftIcon, RefreshCwIcon } from 'lucide-react';
const initialMembers: TeamMember[] = [{
  id: '1',
  name: 'Sarah Jenkins',
  title: 'Senior Loan Officer',
  avatarUrl: 'https://i.pravatar.cc/150?u=sarah',
  isActive: true,
  rules: [{
    id: 'r1a',
    fileType: 'Conventional',
    role: 'Loan Officer',
    isActive: true,
    lastAssigned: '10 mins ago',
    assignedCount: 47
  }, {
    id: 'r1b',
    fileType: 'FHA',
    role: 'Loan Officer',
    isActive: true,
    lastAssigned: '2 hours ago',
    assignedCount: 31
  }, {
    id: 'r1c',
    fileType: 'VA',
    role: 'Loan Officer',
    isActive: false,
    lastAssigned: '3 days ago',
    assignedCount: 12
  }],
  activeFiles: [{
    id: 'f1a',
    loanNumber: 'LN-2024-08234',
    borrowerName: 'Michael & Lisa Torres',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'In Progress',
    assignedDate: 'Mar 11, 2026'
  }, {
    id: 'f1b',
    loanNumber: 'LN-2024-08301',
    borrowerName: 'James Whitfield',
    fileType: 'FHA',
    role: 'Loan Officer',
    status: 'Pending Docs',
    assignedDate: 'Mar 9, 2026'
  }, {
    id: 'f1c',
    loanNumber: 'LN-2024-08187',
    borrowerName: 'Priya Sharma',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'Under Review',
    assignedDate: 'Mar 6, 2026'
  }, {
    id: 'f1d',
    loanNumber: 'LN-2024-07998',
    borrowerName: 'Robert & Anne Chen',
    fileType: 'FHA',
    role: 'Loan Officer',
    status: 'Clear to Close',
    assignedDate: 'Feb 28, 2026'
  }, {
    id: 'f1e',
    loanNumber: 'LN-2024-08102',
    borrowerName: 'Diana Okafor',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'In Progress',
    assignedDate: 'Mar 4, 2026'
  }],
  workload: {
    activeFiles: 5,
    capacity: 20
  },
  lastAssigned: '10 mins ago'
}, {
  id: '2',
  name: 'Marcus Chen',
  title: 'Loan Processor',
  avatarUrl: 'https://i.pravatar.cc/150?u=marcus',
  isActive: true,
  rules: [{
    id: 'r2a',
    fileType: 'Conventional',
    role: 'Processor',
    isActive: true,
    lastAssigned: '1 hour ago',
    assignedCount: 63
  }, {
    id: 'r2b',
    fileType: 'Jumbo',
    role: 'Processor',
    isActive: true,
    lastAssigned: '45 mins ago',
    assignedCount: 28
  }],
  activeFiles: [{
    id: 'f2a',
    loanNumber: 'LN-2024-08290',
    borrowerName: 'Kevin & Maria Santos',
    fileType: 'Conventional',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Mar 10, 2026'
  }, {
    id: 'f2b',
    loanNumber: 'LN-2024-08145',
    borrowerName: 'Thomas Bergström',
    fileType: 'Jumbo',
    role: 'Processor',
    status: 'Pending Docs',
    assignedDate: 'Mar 5, 2026'
  }, {
    id: 'f2c',
    loanNumber: 'LN-2024-08312',
    borrowerName: 'Aisha Williams',
    fileType: 'Conventional',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Mar 11, 2026'
  }, {
    id: 'f2d',
    loanNumber: 'LN-2024-08067',
    borrowerName: 'Gregory & Fiona Park',
    fileType: 'Jumbo',
    role: 'Processor',
    status: 'Under Review',
    assignedDate: 'Mar 2, 2026'
  }, {
    id: 'f2e',
    loanNumber: 'LN-2024-08199',
    borrowerName: 'Natalie Reeves',
    fileType: 'Conventional',
    role: 'Processor',
    status: 'Pending Docs',
    assignedDate: 'Mar 7, 2026'
  }, {
    id: 'f2f',
    loanNumber: 'LN-2024-08256',
    borrowerName: 'Daniel Hoffman',
    fileType: 'Conventional',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Mar 9, 2026'
  }, {
    id: 'f2g',
    loanNumber: 'LN-2024-08321',
    borrowerName: 'Yuki Tanaka',
    fileType: 'Jumbo',
    role: 'Processor',
    status: 'Clear to Close',
    assignedDate: 'Mar 12, 2026'
  }],
  workload: {
    activeFiles: 7,
    capacity: 25
  },
  lastAssigned: '45 mins ago'
}, {
  id: '3',
  name: 'Elena Rodriguez',
  title: 'Mortgage Specialist',
  avatarUrl: 'https://i.pravatar.cc/150?u=elena',
  isActive: false,
  rules: [{
    id: 'r3a',
    fileType: 'FHA',
    role: 'Loan Officer',
    isActive: false,
    lastAssigned: 'Yesterday',
    assignedCount: 19
  }, {
    id: 'r3b',
    fileType: 'VA',
    role: 'Processor',
    isActive: false,
    lastAssigned: '2 days ago',
    assignedCount: 8
  }],
  activeFiles: [{
    id: 'f3a',
    loanNumber: 'LN-2024-08110',
    borrowerName: 'Carlos Mendez',
    fileType: 'FHA',
    role: 'Loan Officer',
    status: 'Pending Docs',
    assignedDate: 'Mar 4, 2026'
  }, {
    id: 'f3b',
    loanNumber: 'LN-2024-08045',
    borrowerName: 'Staff Sgt. Brian Hall',
    fileType: 'VA',
    role: 'Processor',
    status: 'Under Review',
    assignedDate: 'Feb 27, 2026'
  }, {
    id: 'f3c',
    loanNumber: 'LN-2024-08178',
    borrowerName: 'Rosa & Miguel Alvarez',
    fileType: 'FHA',
    role: 'Loan Officer',
    status: 'In Progress',
    assignedDate: 'Mar 6, 2026'
  }],
  workload: {
    activeFiles: 3,
    capacity: 15
  },
  lastAssigned: 'Yesterday'
}, {
  id: '4',
  name: 'David Kim',
  title: 'Junior Loan Officer',
  avatarUrl: 'https://i.pravatar.cc/150?u=david',
  isActive: true,
  rules: [{
    id: 'r4a',
    fileType: 'Conventional',
    role: 'Loan Officer',
    isActive: true,
    lastAssigned: '5 mins ago',
    assignedCount: 22
  }],
  activeFiles: [{
    id: 'f4a',
    loanNumber: 'LN-2024-08330',
    borrowerName: 'Emily & Jason Wright',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'In Progress',
    assignedDate: 'Mar 12, 2026'
  }, {
    id: 'f4b',
    loanNumber: 'LN-2024-08278',
    borrowerName: 'Samantha Liu',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'In Progress',
    assignedDate: 'Mar 10, 2026'
  }, {
    id: 'f4c',
    loanNumber: 'LN-2024-08215',
    borrowerName: 'Mark & Jennifer Adams',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'Pending Docs',
    assignedDate: 'Mar 8, 2026'
  }, {
    id: 'f4d',
    loanNumber: 'LN-2024-08156',
    borrowerName: 'Christopher Dunn',
    fileType: 'Conventional',
    role: 'Loan Officer',
    status: 'Clear to Close',
    assignedDate: 'Mar 5, 2026'
  }],
  workload: {
    activeFiles: 4,
    capacity: 15
  },
  lastAssigned: '5 mins ago'
}, {
  id: '5',
  name: 'Anita Patel',
  title: 'Senior Processor',
  avatarUrl: 'https://i.pravatar.cc/150?u=anita',
  isActive: true,
  rules: [{
    id: 'r5a',
    fileType: 'Conventional',
    role: 'Processor',
    isActive: true,
    lastAssigned: '30 mins ago',
    assignedCount: 89
  }, {
    id: 'r5b',
    fileType: 'FHA',
    role: 'Processor',
    isActive: true,
    lastAssigned: '1 hour ago',
    assignedCount: 54
  }, {
    id: 'r5c',
    fileType: 'VA',
    role: 'Processor',
    isActive: true,
    lastAssigned: '3 hours ago',
    assignedCount: 37
  }, {
    id: 'r5d',
    fileType: 'Jumbo',
    role: 'Processor',
    isActive: false,
    lastAssigned: '5 days ago',
    assignedCount: 11
  }],
  activeFiles: [{
    id: 'f5a',
    loanNumber: 'LN-2024-08298',
    borrowerName: 'William & Sarah Cooper',
    fileType: 'Conventional',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Mar 10, 2026'
  }, {
    id: 'f5b',
    loanNumber: 'LN-2024-08267',
    borrowerName: 'Fatima Al-Rashid',
    fileType: 'FHA',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Mar 9, 2026'
  }, {
    id: 'f5c',
    loanNumber: 'LN-2024-08201',
    borrowerName: 'Lt. Col. David Murray',
    fileType: 'VA',
    role: 'Processor',
    status: 'Pending Docs',
    assignedDate: 'Mar 7, 2026'
  }, {
    id: 'f5d',
    loanNumber: 'LN-2024-08134',
    borrowerName: "Jessica & Ryan O'Brien",
    fileType: 'Conventional',
    role: 'Processor',
    status: 'Under Review',
    assignedDate: 'Mar 5, 2026'
  }, {
    id: 'f5e',
    loanNumber: 'LN-2024-08089',
    borrowerName: 'Andrew Nakamura',
    fileType: 'FHA',
    role: 'Processor',
    status: 'Clear to Close',
    assignedDate: 'Mar 3, 2026'
  }, {
    id: 'f5f',
    loanNumber: 'LN-2024-08045',
    borrowerName: 'Michelle & Steven Grant',
    fileType: 'VA',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Feb 27, 2026'
  }, {
    id: 'f5g',
    loanNumber: 'LN-2024-08334',
    borrowerName: 'Patricia Flores',
    fileType: 'Conventional',
    role: 'Processor',
    status: 'In Progress',
    assignedDate: 'Mar 12, 2026'
  }, {
    id: 'f5h',
    loanNumber: 'LN-2024-08310',
    borrowerName: 'George & Linda Papadopoulos',
    fileType: 'FHA',
    role: 'Processor',
    status: 'Pending Docs',
    assignedDate: 'Mar 11, 2026'
  }],
  workload: {
    activeFiles: 8,
    capacity: 30
  },
  lastAssigned: '30 mins ago'
}, {
  id: '6',
  name: 'Rachel Thompson',
  title: 'Closer',
  avatarUrl: 'https://i.pravatar.cc/150?u=rachel',
  isActive: true,
  rules: [{
    id: 'r6a',
    fileType: 'Conventional',
    role: 'Closer',
    isActive: true,
    lastAssigned: '20 mins ago',
    assignedCount: 72
  }, {
    id: 'r6b',
    fileType: 'FHA',
    role: 'Closer',
    isActive: true,
    lastAssigned: '4 hours ago',
    assignedCount: 41
  }, {
    id: 'r6c',
    fileType: 'Jumbo',
    role: 'Closer',
    isActive: false,
    lastAssigned: '1 week ago',
    assignedCount: 6
  }],
  activeFiles: [{
    id: 'f6a',
    loanNumber: 'LN-2024-08289',
    borrowerName: 'Nathan & Claire Bishop',
    fileType: 'Conventional',
    role: 'Closer',
    status: 'Clear to Close',
    assignedDate: 'Mar 10, 2026'
  }, {
    id: 'f6b',
    loanNumber: 'LN-2024-08245',
    borrowerName: 'Olivia Hernandez',
    fileType: 'FHA',
    role: 'Closer',
    status: 'Clear to Close',
    assignedDate: 'Mar 9, 2026'
  }, {
    id: 'f6c',
    loanNumber: 'LN-2024-08198',
    borrowerName: 'Benjamin & Amy Foster',
    fileType: 'Conventional',
    role: 'Closer',
    status: 'Funded',
    assignedDate: 'Mar 7, 2026'
  }, {
    id: 'f6d',
    loanNumber: 'LN-2024-08167',
    borrowerName: 'Sophia Nguyen',
    fileType: 'Conventional',
    role: 'Closer',
    status: 'Clear to Close',
    assignedDate: 'Mar 6, 2026'
  }, {
    id: 'f6e',
    loanNumber: 'LN-2024-08123',
    borrowerName: 'Derek & Hannah Moore',
    fileType: 'FHA',
    role: 'Closer',
    status: 'Funded',
    assignedDate: 'Mar 4, 2026'
  }, {
    id: 'f6f',
    loanNumber: 'LN-2024-08340',
    borrowerName: 'Isaac Goldstein',
    fileType: 'Conventional',
    role: 'Closer',
    status: 'In Progress',
    assignedDate: 'Mar 13, 2026'
  }],
  workload: {
    activeFiles: 6,
    capacity: 18
  },
  lastAssigned: '20 mins ago'
}, {
  id: '7',
  name: 'James Wilson',
  title: 'Underwriter',
  avatarUrl: 'https://i.pravatar.cc/150?u=james',
  isActive: true,
  rules: [{
    id: 'r7a',
    fileType: 'Conventional',
    role: 'Underwriter',
    isActive: true,
    lastAssigned: '15 mins ago',
    assignedCount: 58
  }, {
    id: 'r7b',
    fileType: 'FHA',
    role: 'Underwriter',
    isActive: true,
    lastAssigned: '2 hours ago',
    assignedCount: 34
  }, {
    id: 'r7c',
    fileType: 'VA',
    role: 'Underwriter',
    isActive: true,
    lastAssigned: '6 hours ago',
    assignedCount: 21
  }],
  activeFiles: [{
    id: 'f7a',
    loanNumber: 'LN-2024-08305',
    borrowerName: 'Amanda & Tyler Reed',
    fileType: 'Conventional',
    role: 'Underwriter',
    status: 'Under Review',
    assignedDate: 'Mar 11, 2026'
  }, {
    id: 'f7b',
    loanNumber: 'LN-2024-08276',
    borrowerName: 'Cpt. Sarah Mitchell',
    fileType: 'VA',
    role: 'Underwriter',
    status: 'Under Review',
    assignedDate: 'Mar 10, 2026'
  }, {
    id: 'f7c',
    loanNumber: 'LN-2024-08234',
    borrowerName: 'Lawrence & Diane Kim',
    fileType: 'FHA',
    role: 'Underwriter',
    status: 'In Progress',
    assignedDate: 'Mar 8, 2026'
  }, {
    id: 'f7d',
    loanNumber: 'LN-2024-08189',
    borrowerName: 'Victoria Osei',
    fileType: 'Conventional',
    role: 'Underwriter',
    status: 'Clear to Close',
    assignedDate: 'Mar 7, 2026'
  }, {
    id: 'f7e',
    loanNumber: 'LN-2024-08342',
    borrowerName: 'Paul & Rebecca Simmons',
    fileType: 'Conventional',
    role: 'Underwriter',
    status: 'Under Review',
    assignedDate: 'Mar 13, 2026'
  }],
  workload: {
    activeFiles: 5,
    capacity: 20
  },
  lastAssigned: '15 mins ago'
}];
export function App() {
  const [members, setMembers] = useState<TeamMember[]>(initialMembers);
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [reassignSourceId, setReassignSourceId] = useState<string | undefined>();
  const [searchQuery, setSearchQuery] = useState('');
  const [statusFilter, setStatusFilter] = useState<'all' | 'active' | 'paused'>('all');
  const [isSyncing, setIsSyncing] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState<string | null>(null);
  const handleSync = useCallback(() => {
    setIsSyncing(true);
    setTimeout(() => {
      setMembers([...initialMembers]);
      setIsSyncing(false);
    }, 1200);
  }, []);
  const handleToggleActive = useCallback((id: string, isActive: boolean) => {
    setMembers(prev => prev.map(m => m.id === id ? {
      ...m,
      isActive,
      rules: m.rules.map(r => ({
        ...r,
        isActive
      }))
    } : m));
  }, []);
  const handleToggleRule = useCallback((memberId: string, ruleId: string, isActive: boolean) => {
    setMembers(prev => prev.map(m => {
      if (m.id !== memberId) return m;
      const updatedRules = m.rules.map(r => r.id === ruleId ? {
        ...r,
        isActive
      } : r);
      const anyActive = updatedRules.some(r => r.isActive);
      return {
        ...m,
        rules: updatedRules,
        isActive: anyActive
      };
    }));
  }, []);
  const handleOpenReassign = useCallback((sourceId?: string) => {
    setReassignSourceId(sourceId);
    setIsReassignModalOpen(true);
  }, []);
  const handleReassign = useCallback((sourceId: string, destId: string, fileIds: string[]) => {
    setMembers(prev => {
      const sourceMember = prev.find(m => m.id === sourceId);
      if (!sourceMember) return prev;
      const filesToMove = sourceMember.activeFiles.filter(f => fileIds.includes(f.id));
      return prev.map(m => {
        if (m.id === sourceId) {
          const remainingFiles = m.activeFiles.filter(f => !fileIds.includes(f.id));
          return {
            ...m,
            activeFiles: remainingFiles,
            workload: {
              ...m.workload,
              activeFiles: remainingFiles.length
            }
          };
        }
        if (m.id === destId) {
          const newFiles = [...m.activeFiles, ...filesToMove];
          return {
            ...m,
            activeFiles: newFiles,
            workload: {
              ...m.workload,
              activeFiles: newFiles.length
            }
          };
        }
        return m;
      });
    });
  }, []);
  const filteredMembers = members.filter(m => {
    const matchesSearch = m.name.toLowerCase().includes(searchQuery.toLowerCase()) || m.title.toLowerCase().includes(searchQuery.toLowerCase());
    const matchesStatus = statusFilter === 'all' || statusFilter === 'active' && m.isActive || statusFilter === 'paused' && !m.isActive;
    return matchesSearch && matchesStatus;
  });
  const selectedMember = members.find(m => m.id === selectedMemberId) || null;
  return <div className="h-screen flex flex-col bg-slate-50 font-sans text-slate-900 overflow-hidden" data-id="element-0">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 flex-shrink-0 z-30" data-id="element-1">
        <div className="px-4 sm:px-6 lg:px-8" data-id="element-2">
          <div className="flex justify-between items-center h-16" data-id="element-3">
            <div className="flex items-center" data-id="element-4">
              <div className="bg-blue-600 p-2 rounded-lg mr-3" data-id="element-5">
                <LayoutDashboardIcon className="h-5 w-5 text-white" data-id="element-6" />
              </div>
              <div data-id="element-7">
                <h1 className="text-lg font-bold text-gray-900 tracking-tight leading-tight" data-id="element-8">
                  Round Robin Command Center
                </h1>
                <p className="text-xs text-gray-500 leading-tight" data-id="element-9">
                  Mortgage File Distribution
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-4" data-id="element-10">
              <div className="flex items-center space-x-2" data-id="element-11">
                <Button variant="outline" size="sm" onClick={handleSync} disabled={isSyncing} data-id="element-12">
                  <RefreshCwIcon className={`h-3.5 w-3.5 mr-1.5 ${isSyncing ? 'animate-spin' : ''}`} data-id="element-13" />
                  {isSyncing ? 'Syncing...' : 'Sync'}
                </Button>
                <Button onClick={() => handleOpenReassign()} className="shadow-sm" size="sm" data-id="element-14">
                  <ArrowRightLeftIcon className="h-3.5 w-3.5 mr-1.5" data-id="element-15" />
                  Mass Reassign
                </Button>
              </div>
              <div className="h-6 w-px bg-gray-200 hidden sm:block" data-id="element-16" />
              <div className="flex items-center space-x-3" data-id="element-17">
                <span className="hidden sm:flex items-center text-xs text-gray-500 bg-gray-50 px-3 py-1.5 rounded-full border border-gray-200" data-id="element-18">
                  <span className="h-1.5 w-1.5 rounded-full bg-green-500 mr-2" data-id="element-19" />
                  Salesforce Connected
                </span>
                <div className="h-8 w-8 rounded-full bg-blue-100 border border-blue-200 flex items-center justify-center" data-id="element-20">
                  <span className="text-blue-700 font-medium text-sm" data-id="element-21">OP</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Stat Strip */}
      <StatCards members={members} data-id="element-22" />

      {/* Two-Panel Layout */}
      <div className="flex flex-1 overflow-hidden" data-id="element-23">
        <TeamSidebar members={filteredMembers} selectedId={selectedMemberId} onSelect={setSelectedMemberId} searchQuery={searchQuery} onSearchChange={setSearchQuery} statusFilter={statusFilter} onStatusFilterChange={setStatusFilter} allCount={members.length} activeCount={members.filter(m => m.isActive).length} pausedCount={members.filter(m => !m.isActive).length} data-id="element-24" />
        <MemberDetail member={selectedMember} onToggleActive={handleToggleActive} onToggleRule={handleToggleRule} onOpenReassign={handleOpenReassign} data-id="element-25" />
      </div>

      <ReassignModal isOpen={isReassignModalOpen} onClose={() => setIsReassignModalOpen(false)} members={members} onReassign={handleReassign} initialSourceId={reassignSourceId} data-id="element-26" />
    </div>;
}